import React, { Fragment, useState } from "react"
import { Link } from "react-router-dom"
import { Nav, NavLink, Modal, ModalHeader, ModalBody } from "reactstrap"
import { scrollToElement } from "../../Code/Utilities"
import { AccountTypes } from "../../Code/Data"
import { useCartData } from "../../Context/cart"
import { useUserData } from "../../Context/user"

export default function MainMenu({ barsClassName }) {
  const [menuVisible, setMenuVisible] = useState(false)
  const { loggedInUser, logout } = useUserData()
  const { cart } = useCartData()

  const toggleModal = () => setMenuVisible(!menuVisible)
  const closeMenu = () => setMenuVisible(false)

  // Close the sidebar whenever the user clicks any link / nav item inside it.
  // Most NavLinks in this menu don't have their own onClick to call
  // toggleModal, so without this delegation the modal stays open after
  // navigating — particularly annoying on narrow screens where the sidebar
  // covers the page the user just navigated to.
  const handleMenuItemClick = (e) => {
    const link = e.target.closest("a, button, [role='menuitem']")
    if (link && link.closest("[role='navigation']")) {
      closeMenu()
    }
  }

  const handleGotoSection = sectionId => () => {
    scrollToElement(`#${sectionId}`, true, 0)
    closeMenu()
  }

  const accountType = loggedInUser?.AccountType
  const cartHasItems = cart?.Items?.length > 0

  return (
    <>
      <Link className={barsClassName || "text-light fs-3"} onClick={toggleModal} to="#">
        <i className={"fa fa-bars"} />
      </Link>
      <Modal
        className="side-menu-modal"
        isOpen={menuVisible}
        toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          {loggedInUser ? (
            <h3>Welcome {loggedInUser.FirstName}!</h3>
          ) : (
            <h3>CharityChoice Main Menu</h3>
          )}
        </ModalHeader>
        <ModalBody role="navigation" onClick={handleMenuItemClick}>
          {loggedInUser && (<>
            <NavLink href="/Account/CreateUserRedemptionPage">Customize your Redeem Page</NavLink>
            <hr /></>
          )}
          <p>Purchase or Donate</p>
          <Nav vertical>
            <NavLink tag={Link} to="/Purchase/DigitalCards">
              Digital Cards
              <sub>100 graphics or upload your own</sub>
            </NavLink>
            <NavLink tag={Link} to="/Purchase/DigitalCards">
              Printable Cards
              <sub>100 graphics or upload your own</sub>
            </NavLink>
            <NavLink tag={Link} to="/Purchase/PhysicalCards">
              Physical Gift Cards
              <sub>Our in-stock physical cards, designs for many occasions</sub>
            </NavLink>
            <NavLink tag={Link} to="/Purchase/CustomPhysicalCards">
              Custom Gift Cards
              <sub>
                Bulk custom physical card orders - customized with your own
                design or logo
              </sub>
            </NavLink>
            <NavLink tag='a' href="/Purchase/RedemptionCodes">
              Get Active Redemption Codes
            </NavLink>
            <NavLink href="/Purchase/Favors-Swag-QR-Codes">
              Multi-Redeemable QR Codes
            </NavLink>
            <NavLink tag={Link} to="/Purchase/HonorCards">
              HonorCards
              <sub>Donate to a specific charity</sub>
            </NavLink>
            <NavLink tag={Link} to="/Purchase/DirectToCharityDonation">
              Make a Donation to Charity
            </NavLink>
            <NavLink tag={Link} to="/DAF">Purchasing with your DAF</NavLink>
            <NavLink tag="a" href="https://donateyourcard.org">DonateYourCard.org
              <sub>Unused gift card balances</sub>
            </NavLink>
          </Nav>
          <hr />
          <p>Corporate and Events</p>
          <Nav vertical>
            <NavLink tag={Link} to="/CorporateSolutions" onClick={toggleModal}>
              Corporate Solutions
            </NavLink>
            <NavLink href="/customPageAdmin/CreateCustomRedemptionPage">
              Online Corporate Customization Wizard
              <sub>
                Custom redemption pages for your business gifts (needs corporate
                account)
              </sub>
            </NavLink>
            <NavLink tag={Link} to="/CorporateSolutions">Events &amp; Meetings</NavLink>
            <NavLink href="/BridalRegistry">
              Wedding Registry and Bridal Favors
            </NavLink>
          </Nav>
          <hr />
          <p>Our Charities</p>
          <Nav vertical>
            <NavLink tag={Link} to="/Charities">
              List of our Charities
              <sub>View our list of Registered Charities</sub>
            </NavLink>
            <NavLink href="/AddNatLocalCharitiesRegistration/">
              Charity Application
              <sub>Register your charity on our list</sub>
            </NavLink>
            <NavLink href="/CharityLogin.aspx">
              Charity Login
              <sub>
                Login to modify your charity account, download reports, user
                optin info, etc.
              </sub>
            </NavLink>
            <NavLink href="/Account/CreateUserRedemptionPage/">
              Customize your Redemption Page
              <sub>Branded page</sub>
            </NavLink>
          </Nav>
          {accountType === AccountTypes.Personal && (
            <Fragment>
              <hr />
              <p>Personal Account</p>
              <Nav vertical>
                <NavLink href="/Account/Update">Modify My Account</NavLink>
                <NavLink href="/Account/Orders">My Orders</NavLink>
              </Nav>
            </Fragment>
          )}
          {accountType === AccountTypes.Charity && (
            <Fragment>
              <hr />
              <p>Charity Account</p>
              <Nav vertical>
                <NavLink href="/Account/Update">Modify My Account</NavLink>
                <NavLink href="/Reports/CharityDistributionReport.aspx">
                  Charity Distribution Reports
                </NavLink>
                <NavLink href="/Account/Update#CharityInformation">
                  Upload or Change Logo
                </NavLink>
                <NavLink tag="a" href="https://donateyourcard.org">
                  Accept Donations of Retail Gift Cards
                </NavLink>
              </Nav>
            </Fragment>
          )}
          {accountType === AccountTypes.Corporate && (
            <Fragment>
              <hr />
              <p>Corporate Account</p>
              <Nav vertical>
                <NavLink href="/Account/Update">Modify My Account</NavLink>
                <NavLink href="/Account/Orders">My Orders</NavLink>
                <NavLink href="/customPageAdmin/CreateCustomRedemptionPage">
                  Online Corporate Customization Wizard
                  <sub>
                    Fully customizable redemption pages for your business gifts (needs corporate
                    account)
                  </sub>
                </NavLink>
              </Nav>
            </Fragment>
          )}
          <hr />
          <NavLink onClick={handleGotoSection("GiveGiftCards")}>
            Purchase
          </NavLink>
          {cartHasItems && (
            <Fragment>
              <NavLink href="/ShoppingCart">My Cart</NavLink>
              <NavLink href="/ShoppingCart">Check Out</NavLink>
            </Fragment>
          )}
          {loggedInUser ? (
            <NavLink
              onClick={() => {
                logout()
                toggleModal()
              }}>
              Log Out of Account
            </NavLink>
          ) : (
            <NavLink href="/Login">Account Login</NavLink>
          )}
          <NavLink href="/FAQs">FAQs, Terms &amp; Conditions</NavLink>
          <NavLink
            href="https://blog.charitygiftcertificates.org"
            target="__blank">
            Blog
          </NavLink>
          <NavLink onClick={handleGotoSection("sitemap")}>
            Full Directory
          </NavLink>
        </ModalBody>
      </Modal>
    </>
  )
}
